module.exports = __webpack_public_path__ + "static/media/bdbi.9c3003da.svg";